import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class CircleIcon extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.object.isRequired,
    className: PropTypes.string,
    size: PropTypes.oneOf(['xsm', 'sm', 'md', 'lg', 'xlg', '2xl']),
    hoverable: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => { },
  }

  get classNames() {
    const { className, size, hoverable } = this.props;
    return classNames('circled-icon', {
      [className]: className,
      'hoverable': hoverable,
      'is-2xl': size === '2xl',
      'is-xlarge': size === 'xlg',
      'is-large': size === 'lg',
      'is-small': size === 'sm',
      'is-xsmall': size === 'xsm',
    });
  }

  render() {
    const { icon, onClick } = this.props;

    return (
      <div {...{
        className: this.classNames,
        onClick,
      }}>
        <FontAwesomeIcon icon={icon} />
      </div>
    );
  }
}